export const scoreValueList = ['1', '2', '3', '4', '5'];
